import {RadioGroup, TextInput} from "omoplay";
import React, {useEffect, useState} from "react";


const BackgroundImageGenerateForm = ({onPrompt}) => {
    const [backgroundImageForm, setBackgroundImageForm] = useState({
        backgroundColor: "#1F1F1F",
        title: "당첨 룰렛",
        titleColor: "#EFEAE4",
        bottomText: "회원이 되어주신 모든 분께",
        bottomTextColor: "#DDDDDD",
        bottomBoldText: "반스힐리조트가 나눠 드립니다!",
        bottomBoldTextColor: "#FBB03B",
    })

    useEffect(() => {
        onPrompt(`1. 전체 배경 및 레이아웃
                    배경색: ${backgroundImageForm.backgroundColor}
                    최상단에 아주 조금의 여유 공간만 두고 골드톤/은색/흰색/회색의 **컨페티(confetti)**와 리본들이 2~3개 정도 흩어져 있음
                    **반드시 이미지는 2:3 비율**
                    2. 상단 텍스트
                    내용: ${backgroundImageForm.title}
                    폰트: 굵고 입체감 있는 고딕 계열, 3D 효과
                    색상: ${backgroundImageForm.title}
                    배치: 컨페티 근처, 한줄 배치, 중앙 정렬
                    효과: 살짝 그림자 효과 / 입체감 강조
                    3. 중앙 영역
                    상단 텍스트와 하단텍스트 사이에 룰렛 삽입을 위한 공간이 존재
                    4. 최하단 텍스트 (설명)
                    배치: **반드시 텍스트는 최하단에 아주 조금의 여유 공간만 남기고 중앙 정렬 배치**
                    첫 줄: ${backgroundImageForm.bottomText}
                    색상: ${backgroundImageForm.bottomTextColor}
                    폰트: 깔끔한 고딕, 일반 두께
                    두 번째 줄 (강조): ${backgroundImageForm.bottomBoldText}
                    강조 색상: ${backgroundImageForm.bottomBoldTextColor}
                    강조 폰트: 두껍고 강조된 고딕체`
        )
    }, [backgroundImageForm])

    return (
        <div className="flex-col gap-4">
            <div className="text-[20px] font-semibold">템플릿을 선택 하세요</div>
            <RadioGroup items={[
                { label: (<img alt="preview_coupon"
                               src="https://img.headless.co.kr/offline_qr_service/7/7684af0c-c10b-4170-bcbe-83c8baa3526b"
                               width="100px" />
                    ), value: "black"}
            ]} onSelected={(items) => console.log(items)} />
            <div className="text-[20px] font-semibold">배경색</div>
            <div className="flex-align-center gap-4">
                <input type="color" value={backgroundImageForm.backgroundColor}
                            onChange={(e) => setBackgroundImageForm((prev) => {
                                return { ...prev, backgroundColor: e.target.value}
                            })} />
            </div>
            <div className="text-[20px] font-semibold">상단 텍스트(최대 5글자)</div>
            <div className="flex-align-center gap-4">
                글자색: <input type="color" value={backgroundImageForm.titleColor}
                            onChange={(e) => setBackgroundImageForm((prev) => {
                                return { ...prev, titleColor: e.target.value}
                            })} />
                <TextInput value={backgroundImageForm.title}
                           onChange={(e) => setBackgroundImageForm((prev) => {
                               return { ...prev, title: e.target.value}
                           })} maxLength="5"
                           />
            </div>
            <div className="text-[20px] font-semibold">하단 텍스트</div>
            <div className="flex-align-center gap-4">
                글자색: <input type="color" value={backgroundImageForm.bottomTextColor}
                            onChange={(e) => setBackgroundImageForm((prev) => {
                                return { ...prev, bottomTextColor: e.target.value}
                            })} />
                <TextInput value={backgroundImageForm.bottomText}
                           onChange={(e) => setBackgroundImageForm((prev) => {
                               return { ...prev, bottomText: e.target.value}
                           })}
                />
            </div>
            <div className="text-[20px] font-semibold">하단 강조 텍스트</div>
            <div className="flex-align-center gap-4">
                글자색: <input type="color" value={backgroundImageForm.bottomBoldTextColor}
                            onChange={(e) => setBackgroundImageForm((prev) => {
                                return { ...prev, bottomBoldTextColor: e.target.value}
                            })} />
                <TextInput value={backgroundImageForm.bottomBoldText}
                           onChange={(e) => setBackgroundImageForm((prev) => {
                               return { ...prev, bottomBoldText: e.target.value}
                           })}
                />
            </div>
        </div>
    )
}

export default BackgroundImageGenerateForm